import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SnackBarService } from 'src/app/shared/services/snackBar.service';
import { LocalizationService } from './localization.service';
import { FireStorageService } from './storage.service';

enum MessageType {
  DELETE = 'delete',
  DELETE_MULTIPLE = 'delete-multiple',
  DELETE_ERROR = 'delete-error'
}

@Injectable({
  providedIn: 'root'
})
export class DeleteFileService {
  private filesToDelete: string[] = [];

  constructor(
    private dialogService: DialogService,
    private fs: FireStorageService,
    private snackBarService: SnackBarService,
    private ls: LocalizationService
  ) {}

  ngOnInit(): void {}

  /** @param file PATH to FireStorage */
  public addFileToDelete(...files: string[]): void {
    this.filesToDelete.push(...files);
  }

  public async deleteFiles(): Promise<void> {
    if (this.filesToDelete.length === 0) {
      return;
    }
    const deletedFilesLength = this.filesToDelete.length;

    const promises = this.filesToDelete.map((file) => this.deleteFile(file));

    await Promise.all(promises);

    this.clearFilesToDelete();

    if (deletedFilesLength === 1) {
      this.snackBarUsage(MessageType.DELETE, '');
    } else {
      this.snackBarUsage(MessageType.DELETE_MULTIPLE, '');
    }
  }

  private async deleteFile(file: string): Promise<void> {
    try {
      await this.fs.deleteFile(file);
    } catch (e: any) {
      if (e.name == 'FirebaseError' && e.code == 'storage/object-not-found') {
        console.warn(`Plik ${file} nie istnieje w bazie`);
      } else {
        this.snackBarUsage(MessageType.DELETE_ERROR, file);
        throw e;
      }
    }
  }

  public confirmDelete$(filename?: string | null, colors: ColorSchemes = ColorSchemes.PRIMARY): Observable<boolean> {
    return this.dialogService.openConfirmationDialog({
      text: filename ? this.ls.trReplace('guard.deleteFileName', { $filename: filename }) : this.ls.translate('guard.deleteFile'),
      acceptKey: 'button.delete',
      cancelKey: 'button.cancel',
      colors
    });
  }

  private snackBarUsage(message: string, file: string): void {
    switch (message) {
      case MessageType.DELETE:
        this.snackBarService.showSuccess(this.ls.translate('success.deleteFile'));
        break;
      case MessageType.DELETE_MULTIPLE:
        this.snackBarService.showSuccess(this.ls.translate('success.deleteFiles'));
        break;
      case MessageType.DELETE_ERROR:
        this.snackBarService.showError(`${this.ls.translate('error.deleteFile')} ${file}.`);
        break;
    }
  }

  public clearFilesToDelete(): void {
    this.filesToDelete = [];
  }
}
